<template>
  <div
    v-if="user"
    class="bg-card personalData"
  >
    <div class="candidate-hero" />
    <div class="candidate-hero-info">
      <!-- TODO: fix them no-image fallback -->
      <img
        v-if="user"
        class="userdata-avatar cv-avatar mx-auto mx-md-0"
        :src="avatarUrl()"
        :onerror="basepath + 'uploads/avatars/no_avatar.jpg'"
        @click="imageFullscreen = true"
      >
    </div>
    <div>
      <div class="row">
        <div class="col-12 col-sm-8 pl-5">
          <h2>{{ user.first_name }} {{ user.last_name }}</h2>
          <p
            v-if="user.city && user.country && user.province"
            class="m-0"
          >
            <font-awesome-icon
              icon="map-marker"
            />
            {{ user.city }} ({{ user.country }}) {{ user.province }}
          </p>
          <div>
            <p
              v-if="!user.email"
              class="m-0"
              style="font-size: 0.9rem"
            >
              <font-awesome-icon
                icon="mail-bulk"
              />
              {{ $t('generic.hidden-contact-details', 'Contact details hidden') }}
            </p>
            <div v-else>
              <p class="m-0">
                <font-awesome-icon
                  icon="envelope"
                />
                {{ user.email }}
              </p>
              <p
                v-if="user.phone"
                class="m-0"
              >
                <font-awesome-icon
                  icon="phone"
                />
                {{ user.phone }}
              </p>
            </div>
          </div>
          <div
            v-if="user && user.cv && user.cv.document"
            class="sm-text download-cv mb-3"
            @click="showCV"
          >
            <font-awesome-icon
              icon="download"
              class="mr-1"
            />
            {{ $t('pages.one-candidate.view-cv', 'View CV') }}
          </div>
          <div
            v-else
            style="font-size: 0.85rem; ont-style: italic;"
          >
            {{ $t('pages.one-candidate.no-document', 'No CV document...') }}
          </div>
        </div>
        <div class="col-12 col-sm-4">
          <div
            v-if="cvExperiences.length"
          >
            <div
              v-for="exp in cvExperiences"
              :key="exp.id"
              class="mt-1"
            >
              <!-- TODO: replace the placeholder here -->
              <img
                class="float-left mr-2 mt-1"
                src="https://placehold.it/32x32"
                alt="Placeholder"
              >
              <div>
                <div>{{ exp.company }}</div>
                <div>{{ exp.startDate }} - {{ exp.endDate || $t('generic.present', 'Present') }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AvatarFullscreenModal
      :open="imageFullscreen"
      :image="avatarUrl()"
      @closeModal="imageFullscreen = false"
    />
  </div>
</template>

<script>
import AvatarFullscreenModal from '@/components/jobs/CV/AvatarFullscreenModal';

export default {
  components: {
    AvatarFullscreenModal
  },
  props: {
    user: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      imageFullscreen: false
    }
  },
  computed: {
    cvExperiences() {
      return (
          (this.user
              && this.user
              && this.user.cv
              && this.user.cv.experience
          )
              ? JSON.parse(this.user.cv.experience)
              : []
      );
    },
    basepath() {
      return process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH;
    }
  },
  methods: {
    avatarUrl() {
      return process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH + 'uploads/avatars/' + this.user.avatar.filename
    },
    showCV() {
      if (this.user && this.user && this.user.cv && this.user.cv.document) {
        window.open(process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH + 'uploads/cv_v2/' + this.user.cv.document);
      } else if (this.user && this.user.cv) {
        window.open(process.env.VUE_APP_API_URL + process.env.VUE_APP_API_PUBLIC_PATH + 'uploads/cv/' + this.user.cv);
      }
    },
  }
}
</script>


<style scoped lang="scss">
  .cv-avatar {
    width: 100px;
    height: 100px;
    border-radius: 50%;
  }

  .edit-button {
    font-size: 0.8rem;
    font-weight: 600;
    padding: 4px 8px;
  }

  .download-cv {
      cursor: pointer;
      transition: 0.2s ease;

      &:hover {
        font-weight: 600;
      }
    }

  .userdata-avatar {
    width: 135px;
    height: 135px;
    border: 1px solid #efefef;
    box-shadow: 2px 3px 15px 10px rgba(0, 0, 0, 0.1), -1px 0 2px 0px rgba(0, 0, 0, 0.05);
    margin-top: -75px;
    cursor: pointer;
    transition: 0.3s ease;

    &:hover {
      border: 3px solid #e1e1e1;
    }
  }

  .candidate-hero {
    background: url('../../../assets/company-hero.png');
    height: 150px;
  }

  .candidate-hero-info {
    background: #f2f2f2;
    display: flex;
    justify-content: space-between;
    padding: 0 2rem 2rem;
    flex-wrap: wrap;

    .middle {
      text-align: left;
      margin: 0 2rem;
      padding: 1.6rem 0;

      h1.title {
        font-size: 1.4rem !important;
        margin-bottom: 0 !important;
      }

      .category {
        font-size: 0.9rem;
      }
    }
  }
</style>
